import { Seo } from "../components/Seo";
import { LegalLayout } from "../components/LegalLayout";

const sections = [
  {
    title: "Information we collect",
    points: [
      "Enquiry form details: your name, phone number, email address, monthly ads budget, city, industry and years in business.",
      "Usage data: pages you visit, device and browser type, and approximate location, collected through analytics cookies.",
    ],
    body: "We collect only what we need to respond to you and run this website:",
  },
  {
    title: "How we use your information",
    points: [
      "To respond to your enquiry and schedule your free strategy call.",
      "To prepare for and deliver our services if you become a client.",
      "To improve our website and understand how visitors use it.",
      "To keep internal records as required by law.",
    ],
    body: "We use the information we collect to:",
  },
  {
    title: "What we never do",
    body: "We do not sell, rent or trade your personal information to anyone, and we do not use your enquiry details for unrelated marketing without your consent.",
  },
  {
    title: "When we share information",
    body: "We share personal information only with trusted service providers who help us operate — such as website hosting and analytics providers — under obligations of confidentiality, or when disclosure is required by law.",
  },
  {
    title: "Data retention",
    body: "We keep your information only for as long as needed for the purpose it was collected, or as required by law. You can ask us to delete your details at any time.",
  },
  {
    title: "Security",
    body: "We apply reasonable technical and organisational measures to protect your information. That said, no method of transmission or storage on the internet is completely secure, and we cannot guarantee absolute security.",
  },
  {
    title: "Your rights",
    body: "You may ask us at any time to access, correct or delete the personal information we hold about you. Simply email chatbudds2@gmail.com and we will act on your request promptly.",
  },
  {
    title: "Cookies",
    body: "This website uses analytics cookies to understand visitor behaviour. You can disable cookies in your browser settings; the site will still work, though some usage insights will not be collected.",
  },
  {
    title: "Third-party links",
    body: "Our website may link to third-party sites such as Meta or Google. We are not responsible for their content or privacy practices — please review their policies separately.",
  },
  {
    title: "Changes to this policy",
    body: "We may update this Privacy Policy from time to time. The date at the top of this page shows when it was last revised.",
  },
  {
    title: "Contact us",
    body: "For any privacy question or request, contact us at chatbudds2@gmail.com, call or WhatsApp +91 84484 44896, or write to Chatbudds, 747, Niti Khand -1, Indirapuram, Ghaziabad.",
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy — Chatbudds"
        description="What information Chatbudds collects through this website, how it is used, and the rights you have over your data."
      />
      <LegalLayout title="Privacy Policy" updated="October 2026" sections={sections} testid="privacy-page" />
    </>
  );
}
